const roleImage = (seed) => `https://picsum.photos/seed/huaju-syn-${seed}/600/600`;

/** 角色分类：与接口 resultType 一致 1弟弟 2姐姐 3哥哥 4师娘 5师傅 */
export const TYPE_TABS = [
  { label: '弟弟', cate: 1 },
  { label: '姐姐', cate: 2 },
  { label: '哥哥', cate: 3 },
  { label: '师娘', cate: 4 },
  { label: '师傅', cate: 5 },
];

const roleSuffix = ['A', 'B', 'C', 'D'];

export const MOCK_SYNTHESIZED_LIST = TYPE_TABS.flatMap(({ label, cate }) =>
  roleSuffix.map((suffix, index) => ({
    id: cate * 100 + index + 1,
    resultType: String(cate),
    resultImg: index === 0 && cate === 1 ? roleImage(`${cate}-${suffix}`) : '',
    resultNo: `HJ-SYN-${cate}${suffix}`,
    synthesisTime: '2026-07-24 15:00:00',
    deliveryTime: index % 2 === 0 ? '2026-07-24 16:00:00' : '',
    deadline: '2026-08-24 15:00:00',
    status: index % 2 === 0 ? 1 : 0,
    collectionName: `禁忌的色彩-${label}${suffix}`,
    nftImage: index === 0 && cate === 1 ? roleImage(`${cate}-${suffix}`) : '',
    roleType: cate,
  })),
);
